import styles from './GuideContents.module.css';

// In-page jump links. Anchors match the section/feature ids rendered by GettingStarted,
// FeatureGuide, CreditsGuide, and GuideOutro. Kept in one place so the page has a single
// contents list to maintain.
const GROUPS = [
  {
    title: 'Start here',
    items: [
      { id: 'getting-started', label: 'Getting started in five steps' },
      { id: 'seller-profile', label: 'Your Seller Profile (ICP)' },
    ],
  },
  {
    title: 'Finding people',
    items: [
      { id: 'contact-hunt', label: 'Contact hunt' },
      { id: 'deep-hunt', label: 'Company-first hunt (Deep Hunt)' },
      { id: 'email-verification', label: 'Email verification' },
      { id: 'website-finder', label: 'Website finder' },
      { id: 'batch-search', label: 'Batch search from a CSV' },
    ],
  },
  {
    title: 'Enriching and writing',
    items: [
      { id: 'list-enrichment', label: 'List enrichment' },
      { id: 'ai-drafting', label: 'AI email drafting' },
    ],
  },
  {
    title: 'Managing your work',
    items: [
      { id: 'chat-sessions', label: 'Chat sessions and history' },
      { id: 'exporting', label: 'Exporting your results' },
      { id: 'credits', label: 'Credits and plan limits' },
      { id: 'best-practices', label: 'Getting the best results' },
    ],
  },
];

export default function GuideContents() {
  return (
    <nav className={styles.section} aria-label="On this page">
      <div className={styles.inner}>
        <span className={styles.kicker}>On this page</span>
        <div className={styles.grid}>
          {GROUPS.map((g) => (
            <div key={g.title} className={styles.group}>
              <span className={styles.groupTitle}>{g.title}</span>
              <ul className={styles.list}>
                {g.items.map((it) => (
                  <li key={it.id}>
                    <a className={styles.link} href={`#${it.id}`}>{it.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
}
